import { Alert, Button, Checkbox, FlashbarProps, FormField, Grid, Input, KeyValuePairs, Link, LiveRegion, Modal, Multiselect, SelectProps, Table, Tabs } from '@cloudscape-design/components';
import Box from '@cloudscape-design/components/box';
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import Header from '@cloudscape-design/components/header';
import SpaceBetween from '@cloudscape-design/components/space-between';
import React, { useEffect, useState } from 'react';
import { addNotification, addNotificationStatus, buildBreadcrumbItems, formatCurrency, formatPhone, getCookie, getUrlVersion, getUserType, isEmail, isValidPhone, setData, setLoading, setParameters, setRUT } from '../../../commons/functions';
import { useGlobalState } from '../../../context/GlobalStateContext';
import { CustomAppLayout, saveMasters } from '../../layout';
import { useRouter } from '../../router';
import { useStore } from '../../store';
const _preserve = React.version;
//import { useStoreAdmin } from '../../../context/useStoreAdmin';
import { formatRut, validateRut } from '@fdograph/rut-utilities';
import { mdiInformation, mdiPencilCircle, mdiPlus, mdiRefresh } from '@mdi/js';
import Icon from '@mdi/react';
import DailyBalances from '../../../../components/charts/DailyBalances';
import Copy from '../../../../components/Copy';
import DPModal from '../../../../components/DPModal';
import EquipmentPicker from '../../../../components/EquipmentPicker';
import BadgeCustom from '../../../../components/extras/BadgeCustom';
import Favorites from '../../../../components/extras/Favorites';
import UserAvatar from '../../../../components/extras/UserAvatar';
import Licences from '../../../../components/Licences';
import SelectCountry from '../../../../components/selects/selectCountry';
import SelectUser from '../../../../components/selects/selectUser';
import SelectUserType from '../../../../components/selects/selectUserTypes';
import TableBookingsFlat from '../../../../components/tables/tableBookingsFlat';
import TableMovements from '../../../../components/tables/tableMovements';
import UserPicker from '../../../../components/UserPicker';
import { fetchWithWatch } from '../../../../hooks/fetchWithWatch';
import { btnIconForm, ItemUser } from '../../../../resources/types';


const pageSize = 20;
type OptionDefinition = SelectProps.Option;


export const AdminUsersPage = () => {
    const { data, menu, parameters, RUT } = useGlobalState();

    type OptionDefinition2 = {
        label: string;
        value: string;
    };



    //const storeAdmin = useStoreAdmin();

    const [sideOpen, setSideOpen] = useState(false);
    const [showModalGroups, setShowModalGroups] = useState(false);
    const [showModalCharges, setShowModalCharges] = useState(false);
    const [newRUT, setNewRUT] = useState('');
    const [isValidNewRUT, setIsValidNewRUT] = useState(false);
    const [activeTab, setActiveTab] = useState("data");

    const [userPickerModal, setUserPickerModal] = useState(false);
    const [equipmentPickerModal, setEquipmentPickerModal] = useState(false);


    const {
        actions: { makeHelpPanelHandler },
    } = useStore();
    const { navigate } = useRouter();

    const [user, setUser] = useState<ItemUser>();
    const [selectedGroups, setSelectedGroups] = React.useState<OptionDefinition[]>([]);
    const [selectedCharges, setSelectedCharges] = React.useState<OptionDefinition[]>([]);

    const [masterGroups, setMasterGroups] = useState()
    const [masterCharges, setMasterCharges] = useState()


    const params = new URLSearchParams(window.location.hash.split('?')[1]);


    useEffect(() => {
        if (data) {
            if (data.groups) {
                const groups = data.groups.map((group: { group: any; idGroup: { toString: () => any; }; }) => ({
                    label: group.group,
                    value: group.idGroup.toString(),
                }));
                setMasterGroups(groups)
            }
            if (data.charges) {
                const charges = data.charges.map((charge: { currency: string; value: number; isActiveCharge: number; charge: any; idCharge: { toString: () => any; }; }) => ({
                    label: charge.charge,
                    value: charge.idCharge.toString(),
                    disabled: charge.isActiveCharge === 0,
                    description: `${charge.currency} ${charge.value}`
                }));
                setMasterCharges(charges)
            }
        }
    }, []);
    useEffect(() => {
    }, [parameters?.period]);
    useEffect(() => {
        setIsValidNewRUT(validateRut(newRUT))
    }, [newRUT]);
    useEffect(() => {
    }, [data]);
    useEffect(() => {
        handleGetData();
    }, [parameters.idUser]);
    useEffect(() => {
        if (params.get('tab') && params.get('tab') !== undefined && params.get('tab') !== null && params.get('tab') !== "") {
            setActiveTab(params.get('tab') || "");
        }
        if (params.get('idUser')) {
            setParameters((prev: any) => ({
                ...prev,
                idUser: params.get('idUser')
            }));
        }
    }, []);


    const handleRUTBlur = () => {
        setRUT(formatRut(RUT))
    }
    const handleRemoveRutTransfer = (value: { RUT: string }) => {
        setUser((prev): ItemUser | undefined => {
            if (!prev) return prev; // nothing to update

            return {
                ...prev,
                rutTransfer: prev.rutTransfer?.filter(rut => rut !== value.RUT) ?? []
            };
        });
    };
    const handleAddNewRUT = () => {
        const formatted = formatRut(newRUT);
        setNewRUT(formatted);

        if (validateRut(formatted)) {
            setUser((prev): ItemUser | undefined => {
                if (!prev) return prev; // handle undefined case

                if (prev.rutTransfer?.includes(formatted)) {
                    return prev; // no change if it already exists
                }

                return {
                    ...prev,
                    rutTransfer: [...(prev.rutTransfer ?? []), formatted],
                };
            });
            setNewRUT("");
        }
    };
    const handlePhoneFocus1 = () => {
        if (!user) return
        setUser({ ...user, phone1: user?.phone1.replace(/\D/g, '') });
    };
    const handlePhoneFocus2 = () => {
        if (!user) return
        setUser({ ...user, phone2: user?.phone2.replace(/\D/g, '') });
    };
    const handlePhoneFocusICE = () => {
        if (!user) return
        setUser({ ...user, ICEPhone: user?.ICEPhone.replace(/\D/g, '') });
    };
    const handlePhoneBlur1 = () => {
        if (!user) return
        if (isValidPhone(user?.phone1)) {
            setUser({ ...user, phone1: formatPhone(user?.phone1) });
        }
    };

    const handlePhoneBlur2 = () => {
        if (!user) return
        if (isValidPhone(user?.phone2)) {
            setUser({ ...user, phone2: formatPhone(user?.phone2) });
        }
    };

    const handlePhoneBlurICE = () => {
        if (!user) return
        if (isValidPhone(user?.ICEPhone)) {
            setUser({ ...user, ICEPhone: formatPhone(user?.ICEPhone) });
        }
    };


    const handleUpdateCharges = async () => {
        if (user && user.idUser) {
            const idCharges: number[] = selectedCharges.map(item => Number(item.value));
            if (!idCharges.includes(0))
                idCharges.push(0);
            try {

                setLoading(true)
                const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'x-routing': '/private/admin/users/charges/update',
                        'JWT': getCookie("JWT"),
                        //  
                    },
                    body: JSON.stringify({
                        idUser: parameters.idUser,
                        idCharges: idCharges
                    }),
                });

                if (!response.ok) { throw new Error(`HTTP error: ${response.status}`); }
                const data = await response.json();

                addNotificationStatus(data, setData);
                if (data.code == 0) {
                    handleGetData()
                }
            } catch (error: any) {
                addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
            } finally { setLoading(false) }
        }
    }

    const handleUpdateLicences = async () => {

        if (user && user.idUser) {
            const idGroups: number[] = selectedGroups.map(item => Number(item.value));
            try {
                setLoading(true)
                const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'x-routing': '/private/admin/users/update.licences',
                        'JWT': getCookie("JWT"),
                        //  
                    },
                    body: JSON.stringify({
                        idUser: parameters.idUser
                    }),
                });

                if (!response.ok) { throw new Error(`HTTP error: ${response.status}`); }
                const data = await response.json();
                addNotificationStatus(data, setData);
                if (data.code == 0) {
                    setUser({ ...user, jsonLicencesUpdated: "" })
                }
            } catch (error: any) {
                addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
            } finally { setLoading(false) }
        }
    }
    const handleUpdateGroups = async () => {

        if (user && user.idUser) {
            const idGroups: number[] = selectedGroups.map(item => Number(item.value));
            if (!idGroups.includes(0))
                idGroups.push(0);
            try {
                setLoading(true)
                const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'x-routing': '/private/admin/users/groups/update',
                        'JWT': getCookie("JWT"),
                        //  
                    },
                    body: JSON.stringify({
                        idUser: parameters.idUser,
                        idGroups: idGroups
                    }),
                });

                if (!response.ok) { throw new Error(`HTTP error: ${response.status}`); }
                const data = await response.json();
                addNotificationStatus(data, setData);
                if (data.code == 0) {
                    handleGetData()
                }
            } catch (error: any) {
                addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
            } finally { setLoading(false) }
        }
    }
    const handleUpdateUser = async () => {
        let msg: FlashbarProps.MessageDefinition[] = [];
        if (user?.phone1 === "")
            msg.push({
                type: "error",
                content: 'Teléfono primario no puede estar vacío',
            })
        if (user?.phone1 !== "" && !isValidPhone(user?.phone1))
            msg.push({
                type: "error",
                content: 'Teléfono primario inválido',
            })
        if (user?.email === "")
            msg.push({
                type: "error",
                content: 'Email primario no puede estar vacío',
            })
        if (user?.email !== "" && !isEmail(user?.email || ""))
            msg.push({
                type: "error",
                content: 'Email primario inválido',
            })
        if (user?.email2 !== "" && !isEmail(user?.email2 || ""))
            msg.push({
                type: "error",
                content: 'Email alternativo inválido',
            })
        if (user?.email !== "" && user?.email2 !== "" && isEmail(user?.email || "") && isEmail(user?.email2 || "") && user?.email === user?.email2)
            msg.push({
                type: "error",
                content: 'Email primario no puede ser identico al email alternativo inválido',
            })
        //addNotification(msg, "error", setData);
        if (msg.length > 0) {
            return;
        }
        if (user) {
            user.phone1 = user.phone1.replace(/\D/g, '');
            user.ICEPhone = user.ICEPhone.replace(/\D/g, '');
            user.phone2 = user.phone2.replace(/\D/g, '');
        }
        try {
            setLoading(true)
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/admin/users/update',
                    'JWT': getCookie("JWT"),
                    //  
                },
                body: JSON.stringify({
                    idUser: user?.idUser,
                    name: user?.name,
                    lastName: user?.lastName,
                    phone1: user?.phone1,
                    ICEPhone: user?.ICEPhone,
                    phone2: user?.phone2,
                    ICEContact: user?.ICEContact,
                    email: user?.email,
                    email2: user?.email2,
                    idUserType: user?.idUserType,
                    isActiveUser: user?.isActiveUser,
                    dateMember: user?.dateMember,
                    dateBirth: user?.dateBirth,
                    canConcileBank: user?.canConcileBank,
                    rutTransfer: user?.rutTransfer,
                    isDeleteUser: user?.isDeleteUser,
                    fineExclude: user?.fineExclude,
                    bookingUnlimited: user?.bookingUnlimited,
                    idCountry: user?.idCountry,
                    masters: ["users"]
                }),
                //body: JSON.stringify({ idUser: user?.idUser, DGAC: true }),
                //mode: 'no-cors'  // Bypasses CORS but limits the response
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const dataWeb = await response.json();
            if (dataWeb.code == 0) {

                if (dataWeb.masters) {
                    saveMasters(dataWeb.masters, data)
                }
                if (dataWeb.user.dateBirth) {
                    //dataWeb.user.dateBirth = parseDotNetDate(dataWeb.user.dateBirth);
                }
                if (dataWeb.user.dateMember) {
                    //dataWeb.user.dateMember = parseDotNetDate(dataWeb.user.dateMember);
                }
                const userType = getUserType(dataWeb.user.idUserType, data);
                dataWeb.user.userTypeUT = userType.ut;
                dataWeb.user.userTypeColor = userType.color;

                if (user?.isActiveUser === 0) {
                    const removeUser = (idUserToRemove: number) => {
                        setData((prev: any) => {
                            const updated = {
                                ...prev,
                                users: prev.users.filter((u: any) => u.idUser !== user.idUser)
                            }

                            localStorage.setItem("data", JSON.stringify(updated));
                            return updated;
                        });
                    }
                    removeUser(user.idUser);
                } else if (user?.isActiveUser === 1) {
                    const addUser = () => {
                        setData((prev: any) => {
                            // avoid duplicates                     
                            const exists = prev.users.some((u: any) => u.idUser === user.idUser);
                            const updated = exists
                                ? prev
                                : {
                                    ...prev, users: [...prev.users, {
                                        idUser: user.idUser,
                                        displayName: user.displayName,
                                        idUserType: user.idUserType,
                                        idUserStatus: user.idUserStatus,
                                        status: "Activo",
                                        RUT: user.RUT,
                                        phone1: user.phone1,
                                        email: user.email,
                                        groupCodes: user.groupCodes || []
                                    }]
                                };
                            localStorage.setItem("data", JSON.stringify(updated));
                            return updated;
                        });
                    }
                    addUser()
                }
                setUser(dataWeb.user)
                if (dataWeb.user.charges.fixed) {
                    const charges = dataWeb.user.charges.fixed.map((charge: { currency: string; value: number; charge: any; idCharge: { toString: () => any; }; }) => ({
                        label: charge.charge,
                        value: charge.idCharge.toString(),
                        description: `Grupo: ${charge.value}`
                    }));
                    setSelectedCharges(charges)
                }
                if (dataWeb.user.groups) {
                    const groups = dataWeb.user.groups.map((group: { group: any; idGroup: { toString: () => any; }; }) => ({
                        label: group.group,
                        value: group.idGroup.toString(),
                    }));
                    setSelectedGroups(groups)
                }
            }

            addNotificationStatus(dataWeb, setData);
        } catch (error: any) {

            addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
        } finally {
            setLoading(false)
        }
    }
    const handleGetBalances = async () => {
        if (parameters.idUser > 0) {
            try {
                setLoading(true)
                const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'x-routing': '/private/admin/movements/balances/list',
                        'JWT': getCookie("JWT"),
                        //  
                    },
                    body: JSON.stringify({
                        idUser: parameters.idUser, limit: 30, orderBy: "dateBalance", order: "desc"
                    }),
                    //mode: 'no-cors'  // Bypasses CORS but limits the response
                });

                if (!response.ok) {
                    throw new Error(`HTTP error: ${response.status}`);
                }
                const dataWeb = await response.json();
                addNotificationStatus(dataWeb, setData);
                if (dataWeb.code == 0) {
                    setUser({ ...user, balances: dataWeb.balances })

                }
            } catch (error: any) {
                addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
            } finally {
                setLoading(false)
            }
        };
    }


    const handleGetBookings = async () => {
        if (parameters.idUser > 0) {
            try {
                setLoading(true)
                const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'x-routing': '/private/global/bookings/list',
                        'JWT': getCookie("JWT"),
                        //  
                    },
                    body: JSON.stringify({
                        idUserOrInstructor: parameters.idUser, limit: 30, orderBy: "dateStart", order: "desc"
                    }),
                    //mode: 'no-cors'  // Bypasses CORS but limits the response
                });

                if (!response.ok) {
                    throw new Error(`HTTP error: ${response.status}`);
                }
                const dataWeb = await response.json();
                addNotificationStatus(dataWeb, setData);
                if (dataWeb.code == 0) {
                    setUser({ ...user, bookings: dataWeb.bookings })

                }
            } catch (error: any) {
                addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
            } finally {
                setLoading(false)
            }
        };
    }
    const handleGetMovements = async () => {
        if (parameters.idUser > 0) {
            try {
                setLoading(true)
                const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'x-routing': '/private/admin/movements/list',
                        'JWT': getCookie("JWT"),
                        //  
                    },
                    body: JSON.stringify({
                        idUser: parameters.idUser, limit: 30, orderBy: "dateTransaction", order: "desc", orderBy2: "idMovement", order2: "desc",
                    }),
                    //mode: 'no-cors'  // Bypasses CORS but limits the response
                });

                if (!response.ok) {
                    throw new Error(`HTTP error: ${response.status}`);
                }
                const dataWeb = await response.json();
                addNotificationStatus(dataWeb, setData);
                if (dataWeb.code == 0) {
                    setUser({ ...user, movements: dataWeb.movements })

                }
            } catch (error: any) {
                addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
            } finally {
                setLoading(false)
            }
        };
    }
    const handleGetData = async () => {
        if (parameters.idUser > 0) {
            try {
                setLoading(true)
                const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'x-routing': '/private/admin/users/get',
                        'JWT': getCookie("JWT"),
                        //  
                    },
                    body: JSON.stringify({
                        idUser: parameters.idUser,
                        groups: true,
                        charges: true,
                        isStudent: true
                    }),
                    //mode: 'no-cors'  // Bypasses CORS but limits the response
                });

                if (!response.ok) {
                    throw new Error(`HTTP error: ${response.status}`);
                }
                const dataWeb = await response.json();
                addNotificationStatus(dataWeb, setData);
                if (dataWeb.code == 0) {
                    setActiveTab("data")
                    if (dataWeb.user.dateBirth) {
                        //dataWeb.user.dateBirth = parseDotNetDate(dataWeb.user.dateBirth);
                    }
                    if (dataWeb.user.dateMember) {
                        //dataWeb.user.dateMember = parseDotNetDate(dataWeb.user.dateMember);
                    }

                    if (dataWeb.user) {
                        dataWeb.user.phone1 = formatPhone(dataWeb.user?.phone1);
                        dataWeb.user.phone2 = formatPhone(dataWeb.user?.phone2);
                        dataWeb.user.ICEPhone = formatPhone(dataWeb.user?.ICEPhone);

                        const userType = getUserType(dataWeb.user.idUserType, data);
                        if (dataWeb.user.idUserType) {
                            dataWeb.user.userTypeUT = userType.ut;
                            dataWeb.user.userTypeColor = userType.color;
                        }
                    }

                    setUser(dataWeb.user)
                    if (dataWeb.user.charges) {
                        const charges = dataWeb.user.charges.map((charge: { currency: string; value: number; charge: any; idCharge: { toString: () => any; }; }) => ({
                            label: charge.charge,
                            value: charge.idCharge.toString(),
                            description: `Grupo: ${charge.value}`
                        }));
                        setSelectedCharges(charges)
                    }
                    if (dataWeb.user.groups) {
                        const groups = dataWeb.user.groups.map((group: { group: any; idGroup: { toString: () => any; }; }) => ({
                            label: group.group,
                            value: group.idGroup.toString(),
                        }));
                        setSelectedGroups(groups)
                    }
                    if (!dataWeb && !dataWeb.user) return
                    let updatedUser = { ...dataWeb.user };
                    if (isValidPhone(updatedUser.phone1)) {
                        updatedUser.phone1 = formatPhone(dataWeb.user?.phone1);
                    }
                    if (isValidPhone(dataWeb.user?.phone2)) {
                        updatedUser.phone2 = formatPhone(dataWeb.user?.phone2);
                    }
                    if (isValidPhone(dataWeb.user?.ICEPhone)) {
                        updatedUser.ICEPhone = formatPhone(dataWeb.user?.ICEPhone);
                    }
                    setUser(updatedUser);

                }
            } catch (error: any) {
                addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
            } finally {
                setLoading(false)
            }
        };
    }
    useEffect(() => {
        if (user && user.idUser > 0) {
            if (activeTab === "movements") {
                handleGetMovements();
            }
            else if (activeTab === "bookings") {
                handleGetBookings();
            }
            else if (activeTab === "balances") {
                handleGetBalances();

            }

        }
    }, [activeTab]);

    return (

        <CustomAppLayout
            splitPanelOpen={sideOpen}
            onSplitPanelToggle={({ detail }) => setSideOpen(detail.open)}
            toolsHide

            contentType="form"
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <>
                    <SpaceBetween direction="vertical" size="xs">


                        <Header

                            //info={<Link onClick={() => setHelpOpen(!helpOpen)}><Icon path={mdiHelpCircleOutline} size={1}></Icon></Link>}
                            actions={
                                <SpaceBetween direction="horizontal" size="xs">
                                    <SelectUser
                                        value={parameters.idUser}
                                        onConfirm={(detail) => {
                                            setUser(undefined)
                                            if (detail) {
                                                setParameters((prev: any) => ({
                                                    ...prev,
                                                    idUser: Number(detail.idUser)
                                                }));

                                            } else {
                                                setParameters((prev: any) => ({
                                                    ...prev,
                                                    idUser: 0
                                                }));


                                            }

                                        }} />
                                    {parameters.idUser > 0 && (<Button style={{ root: btnIconForm }} onClick={handleGetData}><Icon path={mdiRefresh} size={1} /></Button>)}

                                    <Favorites />
                                </SpaceBetween>
                            }
                        /*info={<Link variant="info">Info</Link>}*/
                        >
                            Ficha de socio
                        </Header>

                        {(!user) && (
                            <Alert>
                                Sin usuario seleccionado, realize una búsqueda para seleccionar un usuario, ya sea por nombre, apellido, email, RUT o móvil.
                            </Alert>
                        )}
                        {user && user.idUser > 0 && (
                            <SpaceBetween direction="vertical" size="l">
                                <Header
                                    actions={<>
                                        <SpaceBetween direction="horizontal" size="s">
                                            <Copy value={user?.idUser?.toString() || ""} />
                                            <UserAvatar idUser={user?.idUser || 0} width={35} />
                                        </SpaceBetween>
                                    </>}
                                    variant="h2"
                                    description={<>
                                        Saldo: {formatCurrency(user?.balance || 0, "CLP")} | 45 días: {formatCurrency(user?.balance45 || 0, "CLP")} | Últ acceso: {user.dateLastLogin !== "" ? user.dateLastLogin : "Nunca"}
                                    </>}
                                    info={<><BadgeCustom key={user?.userTypeUT} color={user?.userTypeColor || "grey"}>
                                        {user?.userTypeUT}
                                    </BadgeCustom>{user?.isDeleteUser === 1 && <BadgeCustom color="red">Eliminado</BadgeCustom>}</>}
                                >
                                    {user?.displayName}
                                </Header>

                                <Tabs
                                    variant="default"
                                    onChange={(event) => { setActiveTab(event.detail.activeTabId) }}
                                    activeTabId={activeTab}
                                    key={"id"}
                                    tabs={[
                                        {
                                            label: "Ficha",
                                            id: "data",
                                            content: (
                                                <SpaceBetween direction='vertical' size="s">
                                                    <SpaceBetween direction='horizontal' size="s">
                                                        <div style={{ maxWidth: 200 }}>
                                                            <FormField

                                                                label={<>{"RUT"}</>}
                                                                info={<Copy showText={false} value={user?.RUT || ""} />}

                                                            /*label={<>{"RUT"}<Link href={`#admin/users?idUser=${user?.RUT}`} external variant="primary" ></Link></>}*/
                                                            >
                                                                <Input value={user?.RUT || ""} onChange={(event) => setRUT(event.detail.value.toUpperCase())} onBlur={() => handleRUTBlur()} autoComplete={false} readOnly />
                                                            </FormField>
                                                        </div>
                                                        <div style={{ maxWidth: 200 }}>
                                                            <FormField label="Apellidos">
                                                                <Input value={user?.lastName || ""}
                                                                    onChange={(event) => {
                                                                        if (user) {
                                                                            setUser({ ...user, lastName: event.detail.value.toUpperCase() });
                                                                        }
                                                                    }}
                                                                    autoComplete={false} />
                                                            </FormField></div>
                                                        <div style={{ maxWidth: 200 }}>
                                                            <FormField label="Nombres">
                                                                <Input value={user?.name || ""}
                                                                    onChange={(event) => {
                                                                        if (user) {
                                                                            setUser({ ...user, name: event.detail.value.toUpperCase() });
                                                                        }
                                                                    }}
                                                                    autoComplete={false} />
                                                            </FormField>
                                                        </div>
                                                    </SpaceBetween>
                                                    <SpaceBetween direction='horizontal' size="s">
                                                        <div style={{ maxWidth: 150 }}>
                                                            <FormField label="Teléfono" constraintText="Formato 56XXXXXXXXX">
                                                                <Input value={user?.phone1 || ""} onBlur={() => handlePhoneBlur1()} onFocus={() => handlePhoneFocus1()}
                                                                    invalid={user && user?.phone1 !== "" && !isValidPhone(user?.phone1 || "*")}
                                                                    onChange={(event) => {
                                                                        if (user) {
                                                                            setUser({ ...user, phone1: event.detail.value });
                                                                        }
                                                                        // setFineExclude(detail.checked ? 1 : 0)
                                                                    }}

                                                                    autoComplete={false}

                                                                />
                                                            </FormField>
                                                        </div>

                                                        <div style={{ maxWidth: 200 }}>
                                                            <FormField label="Email">
                                                                <Input value={user?.email || ""}
                                                                    invalid={user && user?.email !== "" && !isEmail(user?.email || "*")}
                                                                    onChange={(event) => {
                                                                        if (user)
                                                                            setUser({ ...user, email: event.detail.value.toLocaleLowerCase() });

                                                                    }} />
                                                            </FormField></div>
                                                        <div style={{ maxWidth: 200 }}>
                                                            <FormField label="Email Alt." constraintText="Opcional">
                                                                <Input value={user?.email2 || ""}
                                                                    invalid={user && user?.email2 !== "" && !isEmail(user?.email2 || "*")}
                                                                    onChange={(event) => {
                                                                        if (user)
                                                                            setUser({ ...user, email2: event.detail.value.toLocaleLowerCase() });
                                                                        // setFineExclude(detail.checked ? 1 : 0)
                                                                    }} />
                                                            </FormField>
                                                        </div>
                                                        <div style={{ maxWidth: 150 }}>
                                                            <FormField label="Nacionalidad">
                                                                <SelectCountry value={user?.idCountry || null} onSelect={(id) => {
                                                                    if (user)
                                                                        setUser({ ...user, idCountry: id });
                                                                }} />
                                                            </FormField>
                                                        </div>
                                                    </SpaceBetween>
                                                    <SpaceBetween direction='horizontal' size="s">

                                                        <div style={{ maxWidth: 200 }}>

                                                            <FormField label="Fecha nacimiento"
                                                                constraintText={user?.age ? `${user.age} años` : ""}
                                                            >
                                                                <DPModal date={user?.dateBirth ? user.dateBirth : ""}
                                                                    yearNext yearPrev
                                                                    onConfirm={(date) => {
                                                                        if (user)
                                                                            setUser({ ...user, dateBirth: date });
                                                                    }}
                                                                />
                                                            </FormField>
                                                        </div>
                                                        <div style={{ maxWidth: 200 }}>
                                                            <FormField label="Fecha ingreso">

                                                                <DPModal date={user?.dateMember ? user.dateMember : ""}
                                                                    today
                                                                    onConfirm={(date) => {
                                                                        if (user)
                                                                            setUser({ ...user, dateMember: date });
                                                                    }}
                                                                />
                                                            </FormField>
                                                        </div>
                                                        <div style={{ maxWidth: 250 }}>
                                                            <FormField label="Tipo de usuario">
                                                                <SelectUserType single={true} value={user?.idUserType} visible={true}
                                                                    onSelect={(idUserType) => {
                                                                        if (idUserType && user) {
                                                                            setUser({ ...user, idUserType: Number(idUserType) });
                                                                        }
                                                                    }} />
                                                            </FormField>
                                                        </div>

                                                        <div style={{ maxWidth: 150 }}>
                                                            <FormField label="Estado">
                                                                <Checkbox checked={user?.isActiveUser === 1} onChange={(event) => {
                                                                    if (user)
                                                                        setUser({ ...user, isActiveUser: event.detail.checked ? 1 : 0 });
                                                                }}>{user?.isActiveUser === 1 ? "Activo" : "Inactivo"}</Checkbox>
                                                            </FormField>
                                                        </div>

                                                    </SpaceBetween>
                                                    <SpaceBetween direction='horizontal' size="s">

                                                        {
                                                            user?.studentCertification !== undefined && (
                                                                <FormField label="Estudiante" constraintText="Vencimiento de justificación de beneficio">
                                                                    <DPModal date={user?.studentCertification ? user.studentCertification : ""}
                                                                        today
                                                                        onConfirm={(date) => {
                                                                            console.log({ ...user, studentCertification: date });
                                                                            setUser({ ...user, studentCertification: date });
                                                                        }}
                                                                        start={new Date()} />

                                                                </FormField>
                                                            )
                                                        }
                                                    </SpaceBetween>

                                                    <LiveRegion>
                                                        <Alert
                                                            type="error"
                                                            header="Contacto ICE">
                                                            <SpaceBetween direction='horizontal' size="s">
                                                                <div style={{ maxWidth: 300 }}>
                                                                    <FormField label="Nombre" constraintText="Persona a contactar en caso de emergencia">
                                                                        <Input value={user?.ICEContact || ""}
                                                                            onChange={(event) => {
                                                                                if (user) {
                                                                                    setUser({ ...user, ICEContact: event.detail.value });
                                                                                }
                                                                                // setFineExclude(detail.checked ? 1 : 0)
                                                                            }}

                                                                            autoComplete={false}

                                                                        />
                                                                    </FormField>
                                                                </div>
                                                                <div style={{ maxWidth: 150 }}>
                                                                    <FormField label="Teléfono">
                                                                        <Input value={user?.ICEPhone || ""} onBlur={() => handlePhoneBlurICE()} onFocus={() => handlePhoneFocusICE()}
                                                                            invalid={user && user?.ICEPhone !== "" && !isValidPhone(user?.ICEPhone || "*")}
                                                                            onChange={(event) => {
                                                                                if (user) {
                                                                                    setUser({ ...user, ICEPhone: event.detail.value });
                                                                                }

                                                                                // setFineExclude(detail.checked ? 1 : 0)
                                                                            }}

                                                                            autoComplete={false}
                                                                        />
                                                                    </FormField></div>
                                                            </SpaceBetween>

                                                        </Alert>
                                                    </LiveRegion>
                                                    <KeyValuePairs
                                                        columns={4}
                                                        items={[
                                                            {
                                                                label: "",
                                                                value: (
                                                                    <Checkbox
                                                                        onChange={({ detail }) => {
                                                                            if (user)
                                                                                setUser({ ...user, canConcileBank: detail.checked ? 1 : 0 });
                                                                        }}
                                                                        description="Usuario recibe abonos por conciliación de Banco hacia cuenta socios"
                                                                        checked={user?.canConcileBank === 1}
                                                                    >
                                                                        Conciliación
                                                                    </Checkbox>
                                                                )

                                                            },
                                                            {
                                                                label: "",
                                                                value: (
                                                                    <Checkbox
                                                                        onChange={({ detail }) => {
                                                                            if (user)
                                                                                setUser({ ...user, isDeleteUser: detail.checked ? 1 : 0 });
                                                                        }}
                                                                        description="Usuario no figura en los reportes y procesos"
                                                                        checked={user?.isDeleteUser === 1}
                                                                    >
                                                                        Eliminado
                                                                    </Checkbox>
                                                                )

                                                            },
                                                            {
                                                                label: "",
                                                                value: (
                                                                    <Checkbox
                                                                        onChange={({ detail }) => {
                                                                            if (user)
                                                                                setUser({ ...user, fineExclude: detail.checked ? 1 : 0 });
                                                                            // setFineExclude(detail.checked ? 1 : 0)
                                                                        }}
                                                                        description="Usuario se encuentra excluido del cobro de multas mensuales por morosidad"
                                                                        checked={user?.fineExclude === 1}
                                                                    >
                                                                        Sin multas
                                                                    </Checkbox>
                                                                )

                                                            },
                                                            {
                                                                label: "",
                                                                value: (
                                                                    <Checkbox
                                                                        onChange={({ detail }) => {
                                                                            if (user)
                                                                                setUser({ ...user, bookingUnlimited: detail.checked ? 1 : 0 });
                                                                            // setFineExclude(detail.checked ? 1 : 0)
                                                                        }}
                                                                        description="Usuario puede reservar más de una vez un equipo"
                                                                        checked={user?.bookingUnlimited === 1}
                                                                    >
                                                                        Reservas múltiples
                                                                    </Checkbox>
                                                                )

                                                            },
                                                        ]}
                                                    />
                                                    {user?.canConcileBank === 1 && (
                                                        <KeyValuePairs
                                                            items={[
                                                                ...(user.rutTransfer?.map((RUT, index) => ({
                                                                    label: `RUT #${index + 1}`,
                                                                    info: <Link onClick={() => handleRemoveRutTransfer({ RUT })}>Remover</Link>,
                                                                    value: RUT
                                                                })) ?? []),
                                                                {
                                                                    label: 'Nuevo RUT',
                                                                    value:

                                                                        <Grid
                                                                            gridDefinition={[{ colspan: 2 }, { colspan: 1 }]}
                                                                        >
                                                                            <div><Input onBlur={() => {
                                                                                if (validateRut(newRUT)) {
                                                                                    setNewRUT(formatRut(newRUT))
                                                                                }
                                                                            }} value={newRUT} onChange={({ detail }) => setNewRUT(detail.value)} /></div>
                                                                            <div><Button onClick={() => handleAddNewRUT()} disabled={!isValidNewRUT}><Icon path={mdiPlus} size={1} /></Button></div>

                                                                        </Grid>

                                                                }
                                                            ]}
                                                        />
                                                    )}
                                                    <Box textAlign='right'><Button variant="primary" onClick={() => { handleUpdateUser(); }}>Actualizar</Button></Box>

                                                </SpaceBetween>
                                            )
                                        },
                                        {
                                            label: "Licencias",
                                            id: "licences",
                                            content: (<>

                                                <Header
                                                    actions={
                                                        <SpaceBetween direction='horizontal' size='xs'>
                                                            <FormField label="Últ actualización">
                                                                {user?.jsonLicencesUpdated}
                                                            </FormField>
                                                            <Button variant='primary' onClick={() => handleUpdateLicences()}>Sync DGAC<Icon path={mdiRefresh} size={1} /></Button>
                                                        </SpaceBetween>

                                                    }
                                                />

                                                <SpaceBetween direction='vertical' size='l'>
                                                    {user?.jsonLicences && user?.jsonLicences.length > 0 ?
                                                        (
                                                            <Licences licences={user?.jsonLicences || []} />
                                                        )
                                                        : (
                                                            <Box textAlign="center" margin={{ vertical: "xxxl" }}>
                                                                <b><Icon path={mdiInformation} size={1} /> No hay licencias sincronizadas con la DGAC para este usuario.</b>
                                                            </Box>
                                                        )}
                                                </SpaceBetween>

                                            </>)
                                        },
                                        {
                                            label: "Grupos",
                                            id: "groups",
                                            content: (
                                                <Table
                                                    stickyHeader
                                                    variant='embedded'
                                                    header={
                                                        <Header actions={
                                                            <SpaceBetween direction='horizontal' size='xs'>
                                                                <Link onClick={() => setShowModalGroups(true)}><Icon path={mdiPencilCircle} size={1.5} /></Link>
                                                            </SpaceBetween>
                                                        }
                                                        />}

                                                    columnDefinitions={[
                                                        {
                                                            id: "groups",
                                                            header: "Grupo",
                                                            cell: item => item.group,
                                                        },
                                                        {
                                                            id: "groupCode",
                                                            header: "Etiqueta",
                                                            cell: item => item?.groupCode,
                                                        },
                                                        {
                                                            id: "dateGroup",
                                                            header: "dateGroup",
                                                            cell: item => item?.dateGroup,
                                                        },
                                                    ]}
                                                    items={user?.groups ?? []}
                                                    empty={
                                                        <Box
                                                            margin={{ vertical: "xs" }}
                                                            textAlign="center"
                                                            color="inherit"
                                                        >
                                                            <SpaceBetween size="m">
                                                                <b>Sin grupos asociados</b>
                                                            </SpaceBetween>
                                                        </Box>
                                                    }
                                                />
                                            )
                                        },
                                        {
                                            label: "Cargos",
                                            id: "charges",
                                            content: (
                                                <Table
                                                    stickyHeader
                                                    variant='embedded'
                                                    header={
                                                        <Header actions={
                                                            <SpaceBetween direction='horizontal' size='xs'>
                                                                <Link onClick={() => setShowModalCharges(true)}><Icon path={mdiPencilCircle} size={1.5} /></Link>
                                                            </SpaceBetween>
                                                        }
                                                        >
                                                        </Header>}
                                                    columnDefinitions={[
                                                        {
                                                            id: "charge",
                                                            header: "Cargo",
                                                            cell: item => item.charge,
                                                        },
                                                        {
                                                            id: "accountPlan",
                                                            header: "Cuenta",
                                                            cell: item => item?.accountPlan
                                                        },
                                                        {
                                                            id: "ammount",
                                                            header: "Monto",
                                                            cell: item => item.currency + " " + formatCurrency(item.ammount, item.currency)

                                                        }
                                                    ]}
                                                    trackBy="idCharge"
                                                    items={user?.charges ?? []}
                                                    empty={
                                                        <Box
                                                            margin={{ vertical: "xs" }}
                                                            textAlign="center"
                                                            color="inherit"
                                                        >
                                                            <SpaceBetween size="m">
                                                                <b>Sin cargos asociados</b>
                                                            </SpaceBetween>
                                                        </Box>
                                                    }
                                                />
                                            )
                                        },
                                        {
                                            label: "Últ movimientos",
                                            id: "movements",
                                            content: (

                                                <TableMovements
                                                    filter={false}
                                                    dateFilter="NONE"
                                                    showUser={false}
                                                    showBalance={true}
                                                    movements={user?.movements || []} visible={true}
                                                />
                                            )
                                        },
                                        {
                                            label: "Saldos",
                                            id: "balances",
                                            content: (
                                                <SpaceBetween direction='vertical' size='l'>
                                                    <DailyBalances idUser={user.idUser} />
                                                    {
                                                        !!user?.balances && user?.balances.length > 0 && (
                                                            <Table
                                                                stickyHeader
                                                                filter={
                                                                    <FormField label="Comportamiento 12M">
                                                                        <img src={`${getUrlVersion()}/resources/images/sparkline?idUser=${user.idUser}`} alt="Sparkline" />

                                                                    </FormField>
                                                                }
                                                                items={user?.balances} variant='embedded' columnDefinitions={[
                                                                    { id: "dateBalance", header: "Fecha", cell: item => item.dateBalance },
                                                                    { id: "openBalance", header: "Inicial", cell: item => formatCurrency(item.openBalance, "CLP") },
                                                                    { id: "charges", header: "Cargos", cell: item => formatCurrency(item.charges, "CLP") },
                                                                    { id: "deposits", header: "Abonos", cell: item => formatCurrency(item.deposits, "CLP") },
                                                                    { id: "closeBalance", header: "Final", cell: item => formatCurrency(item.closeBalance, "CLP") },

                                                                ]} />)}
                                                </SpaceBetween>
                                            )
                                        },
                                        {
                                            label: "Reservas",
                                            id: "bookings",
                                            content: (
                                                <TableBookingsFlat showDate bookings={user?.bookings ?? []} visible={true} />

                                            )
                                        }
                                    ]}
                                />
                            </SpaceBetween>
                        )}
                    </SpaceBetween>

                    <UserPicker
                        visible={userPickerModal}
                        clear={false}
                        close={false}
                        onDismiss={() => {
                            setUserPickerModal(false)
                        }}
                        onConfirm={(user) => {
                            const updatedParameters = {
                                ...parameters, // clone existing keys
                                idUser: Number(user.value), // add or update
                                displayName: user.label // add or update
                            };

                            setParameters(updatedParameters); // updates state + storage
                            setUserPickerModal(false);
                        }}
                    />

                    <EquipmentPicker
                        visible={equipmentPickerModal}
                        clear={false}
                        close={false}
                        onDismiss={() => {
                            setEquipmentPickerModal(false)
                        }}
                        onConfirm={(equipment) => {
                            const updatedParameters = {
                                ...parameters, // clone existing keys
                                idEquipment: Number(equipment) // add or update
                            };

                            setParameters(updatedParameters); // updates state + storage
                            setEquipmentPickerModal(false);
                        }}
                    />
                    <Modal visible={showModalGroups} size="medium"
                        onDismiss={() => setShowModalGroups(false)}
                        header={
                            <Header>Edtiar grupos</Header>
                        }
                        footer={
                            <Box textAlign='right'><Button variant='primary' onClick={() => { handleUpdateGroups(); setShowModalGroups(false) }}>Actualizar grupos</Button></Box>
                        }
                    >
                        <Multiselect
                            selectedOptions={selectedGroups}
                            onChange={({ detail }) =>
                                setSelectedGroups([...detail.selectedOptions])
                            }
                            options={masterGroups}
                            filteringType="auto"
                            placeholder="Seleccionar"
                        />
                    </Modal>
                    <Modal visible={showModalCharges} size="medium"
                        onDismiss={() => setShowModalCharges(false)}
                        header={
                            <Header>Edtiar cargos</Header>
                        }
                        footer={
                            <Box textAlign='right'><Button variant='primary' onClick={() => { handleUpdateCharges(); setShowModalCharges(false) }}>Actualizar cargos</Button></Box>
                        }
                    >
                        <Multiselect
                            selectedOptions={selectedCharges}
                            onChange={({ detail }) =>
                                setSelectedCharges([...detail.selectedOptions])
                            }
                            options={masterCharges}
                            filteringType="auto"
                            placeholder="Seleccionar"
                        />
                    </Modal>


                </>
            }
        />
    );
};
